import { render, staticRenderFns } from "./NotificacionForm.vue?vue&type=template&id=34ccb8e0"
import script from "./NotificacionForm.vue?vue&type=script&lang=js"
export * from "./NotificacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports